<div class="generic-modal-root">
    <ngx-loading [show]="loading"></ngx-loading>
  
    <div class="row-padding">
      <div class="row">
        <form
          *ngIf="form"
          [formGroup]="form"
          class="m-form m-form--fit m-form--label-align-right"
        >
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Event Name </label>
            <div class="col-lg-8" style="display: flex">
              <input
                type="text"
                class="form-control m-input"
                formControlName="eventName"
              />
              <img src="../../assets/app/media/img/icons/info-icon.png" class="tooltip-icon" placement="top" style="top: 8px; position: relative;" tooltip="The name of this event">
            </div>
          </div>
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Event Coordinator </label>
            <div class="col-lg-8" style="display: flex">
              <input
                type="text"
                class="form-control m-input"
                formControlName="eventCoordinator"
              />
              <img src="../../assets/app/media/img/icons/info-icon.png" class="tooltip-icon" placement="top" style="top: 8px; position: relative;" tooltip="The organizer of this event">
            </div>
          </div>
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Beneficiary </label>
            <div class="col-lg-8" style="display: flex">
              <input
                type="text"
                class="form-control m-input"
                formControlName="beneficiary"
              />
              <img src="../../assets/app/media/img/icons/info-icon.png" class="tooltip-icon" placement="top" style="top: 8px; position: relative;" tooltip="The charity that benefited from this event">
            </div>
          </div>
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Start Date </label>
            <div class="col-lg-8" style="display: flex">
              <input
                type="text"
                class="form-control m-input"
                formControlName="startDate"
              />
              <img src="../../assets/app/media/img/icons/info-icon.png" class="tooltip-icon" placement="top" style="top: 8px; position: relative;" tooltip="The date this was event started">
            </div>
          </div>
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> End Date </label>
            <div class="col-lg-8" style="display: flex">
                <input
                type="text"
                class="form-control m-input"
                formControlName="endDate"
              />
              <img src="../../assets/app/media/img/icons/info-icon.png" class="tooltip-icon" placement="top" style="top: 8px; position: relative;" tooltip="The date this event ended">
            </div>
          </div>
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Gross Sales </label>
            <div class="col-lg-8" style="display: flex">
              <input
                type="text"
                class="form-control m-input"
                formControlName="grossSales"
              />
              <img src="../../assets/app/media/img/icons/info-icon.png" class="tooltip-icon" placement="top" style="top: 8px; position: relative;" tooltip="Total sales volume before any fees">
            </div>
          </div>
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> CUE Fees </label>
            <div class="col-lg-8" style="display: flex">
              <input
                type="text"
                class="form-control m-input"
                formControlName="cueFees"
              />
              <img src="../../assets/app/media/img/icons/info-icon.png" class="tooltip-icon" placement="top" style="top: 8px; position: relative;" tooltip="Total amount allocated to CUE Audio">
            </div>
          </div>
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Expenses </label>
            <div class="col-lg-8" style="display: flex">
              <input
                type="text"
                class="form-control m-input"
                formControlName="expenses"
              />
              <img src="../../assets/app/media/img/icons/info-icon.png" class="tooltip-icon" placement="top" style="top: 8px; position: relative;" tooltip="Total amount allocated to the event organizer">
            </div>
          </div>
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Credit Card Fees </label>
            <div class="col-lg-8" style="display: flex">
              <input
                type="text"
                class="form-control m-input"
                formControlName="cardFees"
              />
              <img src="../../assets/app/media/img/icons/info-icon.png" class="tooltip-icon" placement="top" style="top: 8px; position: relative;" tooltip="Total fees from credit card transactions">
            </div>
          </div>
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Total Pot </label>
            <div class="col-lg-8" style="display: flex">
              <input
                type="text"
                class="form-control m-input"
                formControlName="totalPot"
              />
              <img src="../../assets/app/media/img/icons/info-icon.png" class="tooltip-icon" placement="top" style="top: 8px; position: relative;" tooltip="Total amount available for the pot after fees">
            </div>
          </div>
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Prize Total </label>
            <div class="col-lg-8" style="display: flex; border-bottom: 1px solid lightgray; padding-bottom: 50px;">
              <input
                type="text"
                class="form-control m-input"
                formControlName="prizeTotal"
              />
              <img src="../../assets/app/media/img/icons/info-icon.png" class="tooltip-icon" placement="top" style="top: 8px; position: relative;" tooltip="The amount of the total pot that will go to the 5050 winner">
            </div>
          </div>
          <div *ngFor="let p of form.controls.payouts.value"> 
            <div  class="form-group m-form__group row remove-margin">
              <label class="col-lg-4 col-form-label"> Payout Type </label>
              <div class="col-lg-8">
                <input
                type="text" disabled
                [value]="p.type"  
                class="form-control m-input"
              />
              </div>
            </div> 
            <div class="form-group m-form__group row remove-margin">
              <label class="col-lg-4 col-form-label"> Payout Total </label>          
              <div class="col-lg-8">
                <input
                type="text" disabled
                [value]="p.amount"
                class="form-control m-input"
              />
              </div>
            </div>
            <div class="form-group m-form__group row remove-margin">
              <label class="col-lg-4 col-form-label"> Payout Status </label>
              <div class="col-lg-8">
                <input
                type="text" disabled
                [value]="p.status"   
                class="form-control m-input"
              />
              </div>
            </div>
            <div class="form-group m-form__group row remove-margin">
              <label class="col-lg-4 col-form-label"> Payout Date </label>
              <div class="col-lg-8">
                <input
                type="text" disabled
                [value]="p.arrivalDate"   
                class="form-control m-input"
              />
              </div>
            </div>
            <div class="form-group m-form__group row remove-margin">
              <label class="col-lg-4 col-form-label"> Payout Description </label>
              <div style="border-bottom: 1px solid lightgray; padding-bottom: 50px;" class="col-lg-8">
                <input
                type="text" disabled
                [value]="p.description"  
                class="form-control m-input"
              />
              </div>
            </div> 
            
          </div>
  
          <div style="height: 45px;">
            <button
              (click)="close()"
              class="btn btn-success"
              style="margin:10px; float:right"
            >
              Close
            </button>
          </div>
        </form>
      </div>
    </div>
</div>